module.exports = __webpack_public_path__ + "img/ms-icon-310x310.18209d87.png";